"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _images = require("../../assets/images");

var _styles = require("./styles");

var _ModalFooter = require("./ModalFooter");

var _ModalHeader = require("./ModalHeader");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

class Modal extends _react.Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    return this.props.portalize ? /*#__PURE__*/_reactDom.default.createPortal(this.renderContent(), document.querySelector(this.props.portalTarget)) : this.renderContent();
  }

  renderContent() {
    const {
      width,
      padding,
      onBackdropClick,
      showCloseButton,
      onClose,
      render,
      size,
      footerButtons = [],
      headerText,
      headerButtons = [],
      ...restProps
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_styles.StyledModal, _extends({
      size: size,
      width: width,
      padding: padding,
      onClick: onBackdropClick,
      "data-testid": "modal"
    }, restProps), /*#__PURE__*/_react.default.createElement("div", {
      className: "modal_content",
      onClick: e => e.stopPropagation()
    }, showCloseButton && /*#__PURE__*/_react.default.createElement("div", {
      className: "close-container",
      onClick: onClose,
      tabIndex: "0",
      onKeyPress: e => e.key === 'Enter' && onClose(),
      "data-testid": "close-modal"
    }, /*#__PURE__*/_react.default.createElement(_images.Close, null)), headerButtons.length > 0 && /*#__PURE__*/_react.default.createElement(_ModalHeader.ModalHeader, {
      headerText: headerText,
      headerButtons: headerButtons
    }), render && render(), footerButtons.length > 0 && /*#__PURE__*/_react.default.createElement(_ModalFooter.ModalFooter, {
      footerButtons: footerButtons
    })));
  }

}

exports.default = Modal;
Modal.propTypes = {
  /**A  callback function for backdropClick event*/
  onBackdropClick: _propTypes.default.func,

  /** to set visibility of close Icon*/
  showCloseButton: _propTypes.default.bool,

  /** Custom width for Modal*/
  width: _propTypes.default.string,

  /** Custom Height for Modal, default is `auto`*/
  height: _propTypes.default.string,

  /** Padding for Modal content*/
  padding: _propTypes.default.string,

  /** A boolean property for portalize */
  portalize: _propTypes.default.bool,

  /** portal Target*/
  portalTarget: _propTypes.default.string,

  /** A Call back function for Close Icon*/
  onClose: _propTypes.default.func.isRequired,

  /** The render should be function that can be rendered as a React Component(use render prop mechanisms) */
  render: _propTypes.default.func.isRequired,

  /**Modal predefined size's*/
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**Footer with array of button*/
  footerButtons: _propTypes.default.arrayOf(_propTypes.default.shape({
    onClick: _propTypes.default.func.isRequired,
    text: _propTypes.default.string.isRequired,
    isPrimary: _propTypes.default.bool.isRequired,
    disabled: _propTypes.default.bool
  })),

  /**Header with array of button*/
  headerButtons: _propTypes.default.arrayOf(_propTypes.default.shape({
    onClick: _propTypes.default.func.isRequired,
    text: _propTypes.default.string.isRequired,
    isPrimary: _propTypes.default.bool.isRequired,
    disabled: _propTypes.default.bool
  })),

  /** Header Text */
  headerText: _propTypes.default.string
};
Modal.defaultProps = {
  showCloseButton: false,
  width: '444px',
  height: 'auto',
  padding: '20px',
  portalize: true,
  portalTarget: 'body',
  footerButtons: [{
    onClick: () => null,
    text: 'Cancel',
    isPrimary: false
  }, {
    onClick: () => null,
    text: 'Save',
    isPrimary: true
  }],
  headerButtons: [{
    onClick: () => null,
    text: 'Cancel',
    isPrimary: false
  }, {
    onClick: () => null,
    text: 'Save',
    isPrimary: true
  }],
  headerText: 'Header'
};